import { AbstractCommand } from "@astina/paloma-common-ui/src/services/CommandQueue";
import vensoRepository from "@/services/VensoRepository";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
import trans from "@astina/paloma-common-ui/src/services/Translator";
export default class ConfirmVensoOrderGroup extends AbstractCommand {
    groupId;
    accessToken;
    constructor(groupId, accessToken) {
        super();
        this.groupId = groupId;
        this.accessToken = accessToken;
    }
    async execute() {
        try {
            return await vensoRepository.confirmOrderGroup(this.groupId, this.accessToken);
        }
        catch {
            return alerts.error(trans('venso_order_group.confirm_error'));
        }
    }
    name() {
        return 'confirm_venso_order_group';
    }
    needsConfirmation() {
        return true;
    }
}
